import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin } from 'react-bootstrap-icons';

export default function Footer() {

  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-lg-3 box">
            <Link to="/" className="logo">
              <i className="fas fa-shopping-basket"></i>Grocery-store
            </Link>
            <p>
            Grocery store is an online platform to buy grocery products and it will be delivered in no time to your doorstep. So, what are you waiting for!
            </p>
            <div className="share">
              <Link className='btn' to="#" ><Facebook/></Link>
              <Link className='btn' to="#" ><Instagram/></Link>
              <Link className='btn' to="#" ><Twitter/></Link>
              <Link className='btn' to="#" ><Linkedin/></Link>
            </div>
          </div>

          <div className="col-md-4 col-lg-3 box">
            <h3>Our Location</h3>
            <div className="links">
              <Link to="#">India</Link>
              <Link to="#">USA</Link>
              <Link to="#">France</Link>
            </div>
          </div>

          <div className="col-md-4 col-lg-3 box">
            <h3>Quick Links</h3>
            <div className="links">
              <Link to="/">Home</Link>
              <Link to="/category">Category</Link>
              <Link to="/product">Product</Link>
              <Link to="/deal">Deal</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          <div className="col-md-4 col-lg-3 box">
            <h3>Download App</h3>
            <div className="links">
              <Link to="#">Google Play</Link>
              <Link to="#">Windows</Link>
              <Link to="#">MacOS</Link>
              <Link to="#">App Store</Link>
            </div>
          </div>
        </div>
      </div>
      <hr/>
      <div className="credit">
        Created by <span>Gajendra Banjara</span> | All Rights Reserved!
      </div>
    </div>
  );
}
